import { observer } from 'mobx-react-lite'
import { OPGenericList } from '../../common'
import { FC } from 'react'
import { PortfolioManagementOPListRouteState } from './state'
import { ROUTE_PATH } from 'apps/social-referent/src/routes/enums'
import { useParams } from 'react-router-dom'
import { useRouteState } from '@shared/utils'

type ListProps = {
  filters?: any
}

export const ListCare: FC<ListProps> = observer(({ filters }) => {
  const { id: socialReferentId } = useParams()

  const state = useRouteState(PortfolioManagementOPListRouteState, {
    socialReferentId,
  })

  return (
    <OPGenericList
      state={state}
      onCancelUrl={ROUTE_PATH.portfolioManagementCare(socialReferentId)}
      filters={filters}
    />
  )
})
